import { render, staticRenderFns } from "./changePasswordDialog.vue?vue&type=template&id=5971bbb7&"
import script from "./changePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./changePasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./changePasswordDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports